import { render, staticRenderFns } from "./userCitizen.vue?vue&type=template&id=72d9f100&scoped=true&"
import script from "./userCitizen.vue?vue&type=script&lang=js&"
export * from "./userCitizen.vue?vue&type=script&lang=js&"
import style0 from "./userCitizen.vue?vue&type=style&index=0&id=72d9f100&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d9f100",
  null
  
)

export default component.exports